module.exports = __webpack_public_path__ + "img/cashback.3ba48d3d.png";